// src/composables/useDate.js

export function useDate() {
  // Format: "Jan 14, 2026"
  const formatDate = (dateString) => {
    const date = new Date(dateString)

    if (Number.isNaN(date.getTime())) {
      return ''
    }

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(date)
  }

  // Format: "a month ago" / "in 2 days"
  const formatRelative = (dateString) => {
    const date = new Date(dateString)

    if (Number.isNaN(date.getTime())) {
      return ''
    }

    const diffInSeconds = (date.getTime() - Date.now()) / 1000
    const absoluteDiffInSeconds = Math.abs(diffInSeconds)

    const rtf = new Intl.RelativeTimeFormat('en-US', { numeric: 'always' })

    const getRelativeValue = (unitSeconds) => Math.round(diffInSeconds / unitSeconds)
    const formatUnit = (value, unit) => {
      if (value === -1) {
        const article = unit === 'hour' ? 'an' : 'a'
        return `${article} ${unit} ago`
      }

      if (value === 1) {
        const article = unit === 'hour' ? 'an' : 'a'
        return `in ${article} ${unit}`
      }

      return rtf.format(value, unit)
    }

    if (absoluteDiffInSeconds < 60) {
      return formatUnit(getRelativeValue(1), 'second')
    }

    if (absoluteDiffInSeconds < 3600) {
      return formatUnit(getRelativeValue(60), 'minute')
    }

    if (absoluteDiffInSeconds < 86400) {
      return formatUnit(getRelativeValue(3600), 'hour')
    }

    if (absoluteDiffInSeconds < 604800) {
      return formatUnit(getRelativeValue(86400), 'day')
    }

    if (absoluteDiffInSeconds < 2629800) {
      return formatUnit(getRelativeValue(604800), 'week')
    }

    if (absoluteDiffInSeconds < 31557600) {
      return formatUnit(getRelativeValue(2629800), 'month')
    }

    return formatUnit(getRelativeValue(31557600), 'year')
  }

  return {
    formatDate,
    formatRelative
  }
}
